import { apolloApi } from "@/shared/api";
// eslint-disable-next-line no-restricted-imports -- DO NOT COPY THIS LINE. See docs/lints.md.
import { StatsQueryParams } from "@suns/api/generated-client/apollo";
import { StatsGrouping, StatsObject } from "../const";

export async function apolloStatsLoader({
  object,
  grouping,
  params,
  includeTotals = false,
}: {
  object: StatsObject;
  grouping: StatsGrouping;
  params?: StatsQueryParams;
  includeTotals?: boolean;
}) {
  const response = await apolloApi.getStats(object, grouping, params);

  let totals = null;
  if (includeTotals) {
    totals = await apolloApi.getStats(object, StatsGrouping.TOTAL, params);
  }

  return {
    ...response,
    stats: [...(response?.stats ?? []), ...(totals?.stats ?? [])],
  };
}
